<template>
  <div>
    <el-card class="box-card" style="margin-top: 20px">
      <el-row :span="24">
        <el-col :span="12">
          <el-button
            :size="buttonSize"
            type="primary"
            @click="
              selectVideoVisibleBlock = true
              selectVideoVisible = true
            "
            icon="el-icon-plus"
            >选择视频</el-button
          >
          <el-button :size="buttonSize" type="primary" @click="pageList"
            >查询</el-button
          >
        </el-col>
      </el-row>
      <el-table
        v-loading="tableLoading"
        ref="multipleTable"
        :data="page.rows"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%"
        height="520"
        border
        @selection-change="selectionChange"
      >
        <el-table-column prop="name" label="视频名称" align="center">
        </el-table-column>
        <el-table-column prop="size" label="大小" align="center">
          <template slot-scope="scope"
            >{{ (scope.row.size / 1024 / 1024).toFixed(4) }}MB</template
          >
        </el-table-column>
        <el-table-column prop="sort" label="排序" align="center">
        </el-table-column>
        <el-table-column prop label="操作" width="180" align="center">
          <template slot-scope="scope">
            <div class="operationGroup">
              <div class="operationGroup">
                <el-popover placement="bottom" :ref="'popover' + scope.row.id">
                  <div class="operationGroup-flex">
                    <!-- <div style="line-height: 30px">排列至第</div> -->
                    <el-input
                      size="samll"
                      v-model="scope.row.sort"
                      type="number"
                      style="width: 100px; height: 30px; margin-left: 5px"
                    ></el-input>
                    <!-- <div style="line-height: 30px; margin-left: 5px">位</div> -->
                    <el-button
                      size="small"
                      style="height: 30px; margin-left: 10px"
                      @click="closePopover(scope.row.id)"
                      >取消</el-button
                    >
                    <el-button
                      type="primary"
                      style="height: 30px; margin-left: 10px"
                      size="small"
                      @click="sortingSort(scope.row)"
                      >确定</el-button
                    >
                  </div>
                  <el-button slot="reference" type="text" size="small"
                    >排序</el-button
                  >
                </el-popover>
              </div>
              <el-button
                type="text"
                size="small"
                @click="deleteApp(scope.row.id)"
                >删除</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="!tableLoading"
        background
        :page-sizes="[10, 20, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        style="margin-top: 20px; text-align: right"
        :total="page.total"
        :page-size="page.pageSize"
        :current-page="page.pageNumber"
        @size-change="sizeChange"
        @current-change="currentChange"
      ></el-pagination>
    </el-card>
    <!-- 选择视频 -->
    <el-dialog
      title="选择视频"
      :visible.sync="selectVideoVisible"
      width="800px"
      left
    >
      <videoMaterial
        @videoListChange="changeVideoList"
        v-if="selectVideoVisibleBlock"
      ></videoMaterial>
    </el-dialog>
  </div>
</template>

<script>
import videoMaterial from "./videoMaterial.vue";
export default {
  components: { videoMaterial },
  data () {
    return {
      videoInfoIds: [],
      selectVideoVisibleBlock: false,
      selectVideoVisible: false,
      tableLoading: false,
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "id",
        sortOrder: "asc"
      },

      searchForm: {
        pageNumber: "",
        pageSize: ""
      },
      styles: {
        width: "300px"
      },
      formLabelWidth: "80px",
      selection: "",
      multipleSelection: "",
      ids: [],
      fileAction: `${process.env.BASE_URL}/system/uploadFile`,
      fileList: [],
      loading: false,
      buttonSize: document.body.clientWidth < 992 ? "mini" : ""
    };
  },
  methods: {
    sizeChange (pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },
    currentChange (pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    selectionChange (val) {
      this.multipleSelection = val;
      val.map(e => this.ids.push({ id: e.id }));
    },

    closePopover (id) {
      this.$refs[`popover` + id].doClose();
    },
    sortingSort (row) {
      this.api.freeCourses
        .updateAppTencentVideo({ id: row.id, sort: row.sort })
        .then(result => {
          this.$refs[`popover` + row.id].doClose();
          this.pageList()
        })
    },
    changeVideoList (ids) {
      ids.forEach(e => {
        this.videoInfoIds.push(e.id)
      })
      this.addAppTencentVideo(this.videoInfoIds)
      this.selectVideoVisible = false;
      this.selectVideoVisibleBlock = false;
    },
    addAppTencentVideo (videoInfoIds) {
      this.api.freeCourses
        .addAppTencentVideo(videoInfoIds)
        .then(result => {
          this.pageList()
        })
    },
    // 列表
    pageList () {
      this.tableLoading = true
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      this.api.freeCourses
        .pageList(this.searchForm)
        .then(result => {
          this.page.rows = result.data.records;
          this.page.total = result.data.total;
          this.tableLoading = false
        })
        .catch(error => {
          this.tableLoading = false
        });
    },

    deleteApp (id) {
      console.log(id);
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning"
      })
        .then(() => {
          this.api.freeCourses
            .deleteAppTencentVideo(
              [{ id: id }]

            )
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
        })
    },

  },
  mounted () {
    this.pageList();

  }
};
</script>
<style lang="less" rel="stylesheet/less">
.avatar-uploader {
  display: flex;
  flex-wrap: wrap;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 80px;
  height: 80px;
  line-height: 80px;
}
.el-upload-list--picture-card .el-upload-list__item {
  width: 80px;
  height: 80px;
}
.el-upload-list--picture-card {
  display: flex;
  flex-wrap: wrap;
}
</style>



// WEBPACK FOOTER //
// src/components/freeCourses/index.vue